export default __webpack_public_path__ + "static/media/follow-img.3378ad95.jpg";